import React from 'react';
import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  resolve: () => import(
    /* webpackChunkName: "recommended-destinations" */
    /* webpackPreload: true */
    './RecommendedDestinations.js'
  ),
  LoadingComponent: () => <React.Fragment />,
  serverMode: 'defer'
});
